import { Dropdown, Col, Row, Space, Typography, Modal, Button, message } from "antd";
import { useState } from "react";

import { Guid } from "guid-typescript";
import { SearchQuery } from "../code/search-query/search-query";
import { useSelector } from "../store/store";
import { authorizeSelectors } from "../store/authorize";
import Loader from "../controls/Loader";
import { BundleAssignment } from "../repository/data.default";
import { getBundlesAssignmentsExport } from "../repository/data.repository";

import BundlesAssignmentsView from "../components/bundles-assignments/BundlesAssignmentsView";
import BundlesAssignmentsFormDialog from "../components/bundles-assignments/BundlesAssignmentsFormDialog";
import { getProblemMessage } from "../utils/http";

function BundlesAssignmentsPage() {
  const [modal, contextHolder] = Modal.useModal();
  const [searchQuery, setSearchQuery] = useState<SearchQuery>({
    conditions: [],
  });
  const [assignmentInputMode, setAssignmentInputMode] = useState<
    "add" | "update" | "delete" | "view"
  >("add");
  const [assignmentInputOpen, setAssignmentInputOpen] = useState(false);
  const [assignmentInputValues, setAssignmentInputValues] =
    useState<BundleAssignment>({} as any);
  const [triggerView, setTriggerView] = useState(Guid.create().toString());
  const permissions = useSelector(authorizeSelectors.permissions);

  function onSearch(searchQuery: SearchQuery): void {
    setSearchQuery(searchQuery);
  }

  function onAssignmentInputOpen(
    mode: "add" | "update" | "delete" | "view",
    values?: BundleAssignment,
  ): void {
    setAssignmentInputMode(mode);
    setAssignmentInputOpen(true);
    setAssignmentInputValues(values || ({} as any));
  }

  function onAssignmentInputFinish(): void {
    setAssignmentInputOpen(false);
    setAssignmentInputValues({} as any);
    setTriggerView(Guid.create().toString());
  }

  function onAssignmentInputClose(): void {
    setAssignmentInputOpen(false);
    setAssignmentInputValues({} as any);
  }

  function onDownloadExport(): void {
    const loading = modal.info({
      content: (
        <Typography.Text className="m-1 ml-2 inline-block">
          Downloading bundles assignments export file..
        </Typography.Text>
      ),
      footer: null,
      centered: true,
      icon: <Loader />,
    });
    getBundlesAssignmentsExport({
      searchQuery,
      pageNumber: 0,
      pageSize: Number.MAX_SAFE_INTEGER,
    })
      .then(() => {
        loading.destroy();
      })
      .catch((err) => {
        loading.destroy();
        message.error(getProblemMessage(err) || "Failed to download export.");
      });
  }

  return (
    <Col className="relative flex flex-auto flex-col overflow-hidden overflow-y-auto">
      <Row className="sticky top-0 z-10 flex flex-row flex-wrap items-center p-4">
        <Typography.Title className="m-0 flex-auto" level={4}>
          Bundles Assignments
        </Typography.Title>
        <Space className="flex flex-row">
          <Dropdown.Button
            type="primary"
            disabled={!permissions.can("Bundles", "create")}

            className={`${!permissions.can("Bundles", "create") ? "disabled" : ""}`}
            menu={{
              items: [
                {
                  key: "downloadExport",
                  label: "Export to Excel",
                  disabled: !permissions.can("Bundles", "view"),
                  onClick: onDownloadExport,
                },
              ],
            }}
            onClick={() => onAssignmentInputOpen("add")}
          >
            Add Assignment
          </Dropdown.Button>
        </Space>
      </Row>
      <Col className="flex flex-auto flex-col overflow-hidden p-4 pb-4 pt-0">
        <BundlesAssignmentsView
          trigger={triggerView}
          onAction={(key: string, record: any) =>
            onAssignmentInputOpen(key as any, record)
          }
          onSearch={onSearch}
        />
      </Col>
      <BundlesAssignmentsFormDialog
        key={assignmentInputMode}
        mode={assignmentInputMode}
        open={assignmentInputOpen}
        initialValues={assignmentInputValues}
        onFinish={onAssignmentInputFinish}
        onCancel={onAssignmentInputClose}
      />
      {contextHolder}
    </Col>
  );
}

export default BundlesAssignmentsPage;
